<template>
  <!-- นกจากโลโก้ depa: flap = กระพือปีก, hover = ลอยขึ้นลงเบาๆ -->
  <svg
    class="depa-bird"
    :class="{ 'depa-bird--flap': flap, 'depa-bird--hover': hover }"
    :width="size"
    :height="size * 1.6"
    viewBox="715 15 350 570"
    role="img"
    aria-label="depa"
  >
    <defs>
      <linearGradient :id="gradId" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#FFC600" />
        <stop offset="100%" stop-color="#FFF200" />
      </linearGradient>
    </defs>
    <g class="depa-bird__wings">
      <polygon points="718,22 1060,365 862,365" :fill="`url(#${gradId})`" />
      <polygon points="958,262 1018,172 1060,365" :fill="`url(#${gradId})`" />
    </g>
    <polygon points="893,365 1060,365 862,410" fill="#E6CF00" />
    <polygon class="depa-bird__tail" points="862,410 1060,365 755,577" :fill="`url(#${gradId})`" />
  </svg>
</template>

<script>
let uid = 0;

export default {
  name: 'DepaBird',
  props: {
    size: { type: Number, default: 48 },
    flap: { type: Boolean, default: false },
    hover: { type: Boolean, default: false },
  },
  data() {
    uid += 1;
    return { gradId: `depa-bird-grad-${uid}` };
  },
};
</script>

<style scoped>
.depa-bird {
  display: inline-block;
  overflow: visible;
}

.depa-bird__wings {
  transform-box: fill-box;
  transform-origin: 100% 100%;
}

.depa-bird--flap .depa-bird__wings {
  animation: depa-flap 0.5s ease-in-out infinite alternate;
}

.depa-bird--hover {
  animation: depa-hover 2.4s ease-in-out infinite;
}

@keyframes depa-flap {
  from { transform: scaleY(1) skewX(0deg); }
  to { transform: scaleY(0.55) skewX(-8deg); }
}

@keyframes depa-hover {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

/* ปิดแอนิเมชันตามการตั้งค่า / เครื่องที่ตั้งลดการเคลื่อนไหว */
html.no-motion .depa-bird,
html.no-motion .depa-bird__wings {
  animation: none !important;
}
</style>
